import * as React from "react";
import { SizedReadOnlyText } from "../../../../core/components/sizedReadOnlyText/SizedReadOnlyText";
import IRepertoireComponentDataItem from "../../../../redux/types/IRepertoireComponentDataItem";
import { REMOVE_ACTION, SEARCH_VIEW, USAGE_ACCOUNT_NUMBER_STATE_KEY, USAGE_AMOUNT_STATE_KEY, USAGE_APPLICABLE_ROYALTY_RATE_STATE_KEY, USAGE_DETAILS_ROWS_SECTION_KEY, USAGE_ID_STATE_KEY, USAGE_INBOUND_FEES_IN_ERROR_STATE_KEY, USAGE_IPI_NUMBER_STATE_KEY, USAGE_LICENSE_REF_ID_STATE_KEY, USAGE_NAME_STATE_KEY, USAGE_OUTBOUND_FEES_IN_ERROR_STATE_KEY, USAGE_ROWS_SECTION_KEY, USAGE_ROYALTY_RATE_STATE_KEY, USAGE_SENDING_LICENSEE_STATE_KEY, USAGE_SHARE_STATE_KEY, USAGE_SOCIETY_AFFILIATION_STATE_KEY } from "../../../Consts";
import { IRepertoireField } from "../../../types/IRepertoireField";
import { IUsageRowData } from "../../../types/usageTypes/IUsageRowData";
import { PerformanceNumbersSection } from "../performanceNumbersSection/PerformanceNumbersSection";
import DataGridTable from "../../../components/dataGridTable/DataGridTable";
import { ILookupDictionary } from "../../../../lookup/types/ILookupDictionary";
import { IRepertoireStateKeys } from "../../../types/IRepertoireStateKeys";
import { InputNumber, Space, Table, Dropdown } from "antd";
import { SizedActionButton } from "../../../components/actionButton/ActionButton";
import ShowMore from "../../../components/showMore/ShowMore";
import InputWithKebabMenu from "../../../components/inputWithKebabMenu/InputWithKebabMenu";
import { showModal } from "../../../../redux/reducers/ModalReducer";
import { addUsageDetailsRowData, addUsageDetailsShareIPRow } from "../../../../redux/reducers/RepertoireReducer";
import IconTextButton from "../../../components/iconTextButton/IconTextButton";
import { IUsageDetailsRowData } from "../../../types/usageTypes/IUsageDetailsRowData";
import { MessageBanner, MessageType } from "../../../components/messageBanner/MessageBanner";
import { If } from "../../../../core/components/If";
import { EXTERNAL_SVG } from "../../../IconConsts";
import DropdownDataInput from "../../../components/dropdownDataInput/DropdownDataInput";
import { getLookupValues, searchLookupValueByCode } from "../../../../lookup/services/LookupHelpers";
import UsageBodyFields from "./UsageBodyFields";
import { IComponentView } from "../../../../redux/types/ComponentView";
import { DEFAULT_VIEW_NAME } from "../../../components/modalViews/fieldSettingView/utils/usageResultsFieldUtils";
import { Delete20Regular } from "@fluentui/react-icons";
import { IPerformanceNumber } from "../../../types/usageTypes/IPerformanceNumber";

export interface IUsageRowDropdownProps {
    usage: IUsageRowData;
    usageDataGridTableData: IRepertoireComponentDataItem;
    componentInstance: string;
    lookupValues?: ILookupDictionary;
    changeData?: (value: any, name: IRepertoireStateKeys, objectKey?: string, ipRepresentationsIdsToRemove?: number[]) => void;
    showModal: (
        modalContent: string,
        modalComponentInstance: string,
        modalProps: any,
        displayModalCloseButton: boolean,
        title: string,
        modalMessage?: string,
        isReadOnly?: boolean,
        key?: string,
        index?: number

    )=>void;
    addUsageDetailsShareIPRow?: typeof addUsageDetailsShareIPRow;
    addUsageDetailsRowData?: typeof addUsageDetailsRowData;
    usageRowViewIndex: number;
    tableContents: any;
    resetMessageBanner: () => void;
    handleApplyAdjustmentToAllSelectedUsages?: (indexOfAdjustment: number, usageRowViewIndex: number) => void;
    isThisApplyAdjustmentToAllSelectedUsagesButtonDisabled?: (indexOfAdjustment: number, usageDetailsIndex: number, usageRowViewIndex: number) => boolean;
    changeUsageData: (value: any, name: string)  => void;
    getMaxWidth: (fieldName: string) => number;
    activeComponentView?: IComponentView;
    usageNumberInSearchExclude?: string[];
    isNewUsageRow?: boolean;
    onChangePerformanceNumbers?: (performanceNumbers: IPerformanceNumber[]) => void;
}

export interface IUsageDetailsAdjustmentsDataItem {
    direction: string;
    id: string,
    ipiNumber: number,
    name: string,
    accountNumber: string,
    societyAffiliation: string,
    share: string,
    applicableRoyaltyRate: string,
    amount: string,
    licenseRefID: number,
    royaltyRate: string,
    inboundFeesInError: string,
    outboundFeesInError: string,
    adjustmentSource: string,
    adjustmentReason: string,
}

interface IUsageRowDropdownState {
    usageDetailsIndex: number;
}

export class UsageRowDropdown extends React.PureComponent<
    IUsageRowDropdownProps,
    IUsageRowDropdownState
    > {
    viewData;
    constructor(props: IUsageRowDropdownProps) {
        super(props);
        this.viewData = {};
        this.state = {
            usageDetailsIndex: 0,
        }
    }

    createViewData() {
        const {
            usageDataGridTableData: { fields },
            componentInstance,
        } = this.props;
        let filteredFields: IRepertoireField[] = [];
        filteredFields = fields.filter(
                (field: IRepertoireField) => field.componentInstance === componentInstance);
        filteredFields.forEach(item => this.viewData[item.name] = item.data);
    }

    componentDidMount(): void {
        this.createViewData();
    }

    addRowToUsageDetails = (index) => {
        const { usage, usageRowViewIndex, addUsageDetailsShareIPRow } = this.props;
        let data: IUsageDetailsAdjustmentsDataItem[] = [];
        if(usage && usage.usageDetails) {
            usage.usageDetails[index].adjustments.forEach(ele => {
                data.push(ele);
            })
            data.push({
                direction: 'To',
                id: usage.usageDetails[index].id,
                ipiNumber: 0,
                name: '',
                accountNumber: usage.usageDetails[index].accountNumber,
                societyAffiliation: '',
                share: '0',
                applicableRoyaltyRate: '0',
                amount: '0',
                licenseRefID: usage.usageDetails[index].licenseRefID,
                royaltyRate: '0',
                inboundFeesInError: usage.usageDetails[index].inboundFeesInError,
                outboundFeesInError: usage.usageDetails[index].outboundFeesInError,
                adjustmentSource: null,
                adjustmentReason: null
            })
        }
        addUsageDetailsShareIPRow(data, usageRowViewIndex, index);
    }

    buildFromRow = (element: IUsageDetailsRowData): IUsageDetailsAdjustmentsDataItem => {
        const societyAffiliation = searchLookupValueByCode("Agency", this.props.lookupValues, element.society);
        return {
            direction: 'From',
            id: element.rightOwnerIPINameNumber.toString(),
            ipiNumber: element.ipiNumber,
            name: element.name,
            accountNumber:  element.accountNumber,
            societyAffiliation: societyAffiliation,
            share: element.sharePercentage,
            applicableRoyaltyRate: element.applicableRoyaltyRate,
            amount: element.amount,
            licenseRefID: element.licenseRefID,
            royaltyRate: element.royaltyRate,
            inboundFeesInError: element.inboundFeesInError,
            outboundFeesInError: element.outboundFeesInError,
            adjustmentSource: null,
            adjustmentReason: null
        };
    }

    onInputChange = (e, key, usageDetailsIndex, childIndex, id) => {
        const { usage, usageRowViewIndex, addUsageDetailsShareIPRow } = this.props;
        let data: IUsageDetailsAdjustmentsDataItem[] = [];

        if (!usage.usageDetails[usageDetailsIndex].adjustments.some(a => a.direction === 'From')) {
            usage.usageDetails[usageDetailsIndex].adjustments.unshift(this.buildFromRow(usage.usageDetails[usageDetailsIndex]));
        }

        if (e !== undefined && e !== null) {
            if (key === 'ipiNumber') {
                usage.usageDetails[usageDetailsIndex].adjustments[childIndex][key] = e;
            } else if (key === 'share') {
                const fromAdj = usage.usageDetails[usageDetailsIndex].adjustments.filter(each => each.direction === "From");
                const totalShare = fromAdj.reduce((acc, each) => acc + parseFloat(each.share), 0);
                const ratio = totalShare !== 0 ? e / totalShare : 0;

                usage.usageDetails[usageDetailsIndex].adjustments[childIndex][key] = e.toString();
                usage.usageDetails[usageDetailsIndex].adjustments[childIndex]['amount'] = (ratio * fromAdj.reduce((acc, each) => acc + parseFloat(each.amount), 0)).toFixed(10).toString();
                usage.usageDetails[usageDetailsIndex].adjustments[childIndex]['applicableRoyaltyRate'] = (ratio * fromAdj.reduce((acc, each) => acc + parseFloat(each.applicableRoyaltyRate), 0)).toFixed(10).toString();
                usage.usageDetails[usageDetailsIndex].adjustments[childIndex]['royaltyRate'] = (ratio * fromAdj.reduce((acc, each) => acc + parseFloat(each.royaltyRate), 0)).toFixed(10).toString();

            } else if (key === 'applicableRoyaltyRate' || key === 'amount' || key === 'royaltyRate' || key === 'outboundFeesInError') {
                usage.usageDetails[usageDetailsIndex].adjustments[childIndex][key] = e.toString();
            }
            else {
                usage.usageDetails[usageDetailsIndex].adjustments.find(x => x.id === id)[key] = e;
            }
        } 
        else if (key === 'ipiNumber' || key === 'share' || key === 'applicableRoyaltyRate' || key === 'amount' || key === 'royaltyRate') {
            usage.usageDetails[usageDetailsIndex].adjustments[childIndex][key] = null;
        }
        usage.usageDetails[usageDetailsIndex].adjustments.forEach(adj => data.push(adj));
        addUsageDetailsShareIPRow(data, usageRowViewIndex, usageDetailsIndex);
    };

    showSearchModal = (modalProps: any) => {
        const { showModal } = this.props;
        showModal(SEARCH_VIEW, USAGE_DETAILS_ROWS_SECTION_KEY, modalProps, true, "Search");
    };

    onClickRemove = (direction: string, usageDetailsIndex: number, childindex: number, usageDetails?: IUsageDetailsRowData) => {
        const { usage, usageRowViewIndex, addUsageDetailsShareIPRow } = this.props;
        let data: IUsageDetailsAdjustmentsDataItem[] = [];
        if (direction === 'From') {
            data = [];
        }
        else if (direction === 'To') {
            if(usage.usageDetails && usage.usageDetails.length > 0 && usage.usageDetails[usageDetailsIndex].adjustments && usage.usageDetails[usageDetailsIndex].adjustments.length > 0) {
                usage.usageDetails[usageDetailsIndex].adjustments.splice(childindex, 1);
                usage.usageDetails[usageDetailsIndex].adjustments.forEach(adj => data.push(adj));
                if(usage.usageDetails[usageDetailsIndex].adjustments && usage.usageDetails[usageDetailsIndex].adjustments.length === 1) {
                    data = [];
                }
            }
        }
        addUsageDetailsShareIPRow(data, usageRowViewIndex, usageDetailsIndex);
    };

    onClickAddUsageDetails = (index) => {
        const { usage, usageRowViewIndex, addUsageDetailsShareIPRow } = this.props;
        let data: IUsageDetailsAdjustmentsDataItem[] = [];

        if(usage && usage.usageDetails && usage.usageDetails[index].adjustments && usage.usageDetails[index].adjustments.length === 0) {
            
            const societyAffiliation = searchLookupValueByCode("Agency", this.props.lookupValues, usage.usageDetails[index].society);

            data.push({
                direction: 'From',
                id: usage.usageDetails[index].id,
                ipiNumber: usage.usageDetails[index].ipiNumber,
                name: usage.usageDetails[index].name,
                accountNumber:  usage.usageDetails[index].accountNumber,
                societyAffiliation: societyAffiliation,
                share: usage.usageDetails[index].share,
                applicableRoyaltyRate: usage.usageDetails[index].applicableRoyaltyRate,
                amount: usage.usageDetails[index].amount,
                licenseRefID: usage.usageDetails[index].licenseRefID,
                royaltyRate: usage.usageDetails[index].royaltyRate,
                inboundFeesInError: usage.usageDetails[index].inboundFeesInError,
                outboundFeesInError: usage.usageDetails[index].outboundFeesInError,
                adjustmentSource: null,
                adjustmentReason: null
            })
    
            data.push({
                direction: 'To',
                id: usage.usageDetails[index].id,
                ipiNumber: usage.usageDetails[index].ipiNumber,
                name: usage.usageDetails[index].name,
                accountNumber:  usage.usageDetails[index].accountNumber,
                societyAffiliation: '',
                share: usage.usageDetails[index].share,
                applicableRoyaltyRate: usage.usageDetails[index].applicableRoyaltyRate,
                amount: usage.usageDetails[index].amount,
                licenseRefID: usage.usageDetails[index].licenseRefID,
                royaltyRate: usage.usageDetails[index].royaltyRate,
                inboundFeesInError: usage.usageDetails[index].inboundFeesInError,
                outboundFeesInError: usage.usageDetails[index].outboundFeesInError,
                adjustmentSource: null,
                adjustmentReason: null
            })
            this.setState({usageDetailsIndex: index})
            addUsageDetailsShareIPRow(data, usageRowViewIndex, index);
        }
    }

    onUpdateUsageRowDetails = (value: IUsageDetailsRowData[], fieldName: string, index: number) => {
        const { usageRowViewIndex, addUsageDetailsRowData } = this.props;
        addUsageDetailsRowData(value, usageRowViewIndex, index, fieldName);
    }    

    onInputClick = (e: React.MouseEvent<HTMLInputElement>) => {
        e.currentTarget.select();
    };

    render() {
        const {
            usage,
            usageDataGridTableData,
            lookupValues,
            changeData,
            usageRowViewIndex,
            resetMessageBanner,
            addUsageDetailsShareIPRow,
            handleApplyAdjustmentToAllSelectedUsages,
            isThisApplyAdjustmentToAllSelectedUsagesButtonDisabled,
            changeUsageData,
            getMaxWidth,
            usageNumberInSearchExclude
        } = this.props;
        const {
            usageDetailsIndex,
        } = this.state;

        const amountOfColumns: number = Object.entries(usage).filter(x => x => x[1] !== null && x[1].inputType === 'row').length + 1;
        const readOnlyTextSize: string = "col-md-6";

        this.createViewData();
        let tableList = [];
        let usageDetailsGridData =[];

        usage.usageDetails = usage.usageDetails.filter(item => {
            return item != null || item === undefined;
        })
       
        if (usage.usageDetails && usage.usageDetails.length > 0) {
            
            usage.usageDetails.forEach((element, index) => {
                if (element.adjustments && element.adjustments.length > 0) {
                    let data: IUsageDetailsAdjustmentsDataItem[] = [];
                    data = element.adjustments.sort((p1, p2) => (p1.direction < p2.direction) ? -1 : (p1.direction > p2.direction) ? 1 : 0);
                    if (!data.some(a => a.direction === 'From')) {
                        data.unshift(this.buildFromRow(element));
                    }
                    let columns = [
                        {
                            title: '', dataIndex: 'direction', key: 'direction', render: (_, value, index) => {
                                const text = value.direction;
                                return <><Space size="middle">{text}</Space></>
                            },
                        },
                        {
                            title: this.viewData[USAGE_ID_STATE_KEY], dataIndex: 'id', key: 'id', render: (text, value, index) => {
                                return <><div className={"percentageField"}><span>{value.id}</span></div></>
                            }
                        },
                        {
                            title: this.viewData[USAGE_IPI_NUMBER_STATE_KEY], dataIndex: 'ipiNumber', key: 'ipiNumber', render: (text, value, childIndex) => (
                                <InputWithKebabMenu
                                    variant="table"
                                    className="hasIcon"
                                    kebab={(value.direction === 'To') ? (
                                        <ShowMore
                                            options={[
                                                {
                                                    text: 'Select IP',
                                                    onClick: () => { this.showSearchModal({ usageDetailsIndex: index, usageRowIndex: usageRowViewIndex, adjustmentsIndex: childIndex }); },
                                                    icon: EXTERNAL_SVG
                                                }
                                            ]}
                                        />
                                    ) : null}
                                >
                                    <InputNumber className={"widerFieldNumber"} value={value.ipiNumber} readOnly={value.direction === 'From'} controls={false} parser={(val) => val ? val.replace(/[^\d.]/g, '') : ''} onChange={event => this.onInputChange(event, "ipiNumber", index, childIndex, value.id)} onClick={this.onInputClick} />
                                </InputWithKebabMenu>
                            )
                        },
                        {
                            title: this.viewData[USAGE_NAME_STATE_KEY], dataIndex: 'name', key: 'name', render: (text, value, index) => {
                                return <><div className={"widerFieldNumber"}><span>{value.name}</span></div></>
                            }
                        },
                        {
                            title: this.viewData[USAGE_ACCOUNT_NUMBER_STATE_KEY], dataIndex: 'accountNumber', key: 'accountNumber', render: (text, value, index) => {
                                return <><div className={"accountNumber"}><span>{value.accountNumber}</span></div></>
                            }
                        },
                        {
                            title: this.viewData[USAGE_SOCIETY_AFFILIATION_STATE_KEY], dataIndex: 'societyAffiliation', key: 'societyAffiliation', render: (text, value, index) => {
                                return <><div className={"percentageField"}><span>{value?.direction === "From" ? value.societyAffiliation : ''}</span></div></>
                            }
                        },
                        {
                            title: this.viewData[USAGE_SHARE_STATE_KEY], dataIndex: 'share', key: 'share', render: (text, value, childIndex) => {
                                return <InputNumber className={"percentageField"} value={value.share} readOnly={value.direction === 'From'} controls={false} parser={(val) => val ? val.replace(/[^\d.]/g, '') : ''} onChange={event => this.onInputChange(event, "share", index, childIndex, value.id)} onClick={this.onInputClick} />
                            }
                        },
                        {
                            title: this.viewData[USAGE_APPLICABLE_ROYALTY_RATE_STATE_KEY], dataIndex: 'applicableRoyaltyRate', key: 'applicableRoyaltyRate', render: (text, value, childIndex) => {
                                return <InputNumber className={"percentageField"} value={value.applicableRoyaltyRate} readOnly={value.direction === 'From'} controls={false} parser={(val) => val ? val.replace(/[^\d.]/g, '') : ''} onChange={event => this.onInputChange(event, "applicableRoyaltyRate", index, childIndex, value.id)} onClick={this.onInputClick} />
                            }
                        },
                        {
                            title: this.viewData[USAGE_AMOUNT_STATE_KEY], dataIndex: 'amount', key: 'amount', render: (text, value, childIndex) => {
                                return <InputNumber className={"percentageField"} value={value.amount} readOnly={value.direction === 'From'} controls={false} parser={(val) => val ? val.replace(/[^\d.]/g, '') : ''} onChange={event => this.onInputChange(event, "amount", index, childIndex, value.id)} onClick={this.onInputClick} />
                            }
                        },
                        {
                            title: this.viewData[USAGE_LICENSE_REF_ID_STATE_KEY], dataIndex: 'licenseRefID', key: 'licenseRefID', render: (text, value, index) => {
                                return <><div className={"widerFieldNumber"}><span>{value.licenseRefID}</span></div></>
                            }
                        },
                        {
                            title: this.viewData[USAGE_ROYALTY_RATE_STATE_KEY], dataIndex: 'royaltyRate', key: 'royaltyRate', render: (text, value, childIndex) => {
                                return <InputNumber className={"percentageField"} value={value.royaltyRate} readOnly={value.direction === 'From'} controls={false} parser={(val) => val ? val.replace(/[^\d.]/g, '') : ''} onChange={event => this.onInputChange(event, "royaltyRate", index, childIndex, value.id)} onClick={this.onInputClick} />
                            }
                        },
                        {
                            title: this.viewData[USAGE_INBOUND_FEES_IN_ERROR_STATE_KEY], dataIndex: 'inboundFeesInError', key: 'inboundFeesInError', render: (text, value, index) => {
                                return <><div className={"widerFieldNumber"}><span>{value.inboundFeesInError}</span></div></>
                            }
                        },
                        {
                            title: this.viewData[USAGE_OUTBOUND_FEES_IN_ERROR_STATE_KEY], dataIndex: 'outboundFeesInError', key: 'outboundFeesInError', render: (text, value, childindex) => {
                                return <DropdownDataInput 
                                    value={value.outboundFeesInError} 
                                    changeData={event => this.onInputChange(event, "outboundFeesInError", index, childindex, value.id)}
                                    fieldName="Outbound Fees In Error"
                                    options={getLookupValues("UsagesFeesError", lookupValues)}
                                    allowNull={true}
                                    isHidden={false}
                                />
                            }
                        },
                        {
                            title: '', dataIndex: REMOVE_ACTION, key: REMOVE_ACTION, render: (text, value, childindex) => (
                                value.direction === 'From' ?
                                    <div className="tableCell">
                                        <IconTextButton onClick={() => this.onClickRemove('From', index, childindex, value)} text={'Detail'} icon={Delete20Regular} disabled={value.dataSource === 'Posted'} />
                                    </div>
                                    :
                                    <div>
                                        <IconTextButton onClick={() => this.onClickRemove('To', index, childindex, value)} text={'Row'} icon={Delete20Regular} disabled={value.dataSource === 'Posted'} />
                                    </div>
                            )
                        }
                    ]

                    tableList.push(
                        <div className='tableContainer'>
                            {element.errorMessage && element.errorMessage.map((errorKey, i) => {
                                const field = usageDataGridTableData.fields.find(x => x.name.toString() === errorKey);
                                if (!field) return null;
                                return <MessageBanner
                                    key={i}
                                    resetMessageBanner={() => { element.errorMessage = element.errorMessage.filter(e => e !== errorKey); resetMessageBanner(); }}
                                    messageType={MessageType.Danger}
                                    messages={[field.data]}
                                />;
                            })}
                            <Table
                                rowClassName={(record, index) => index % 2 === 0 ? 'table-row-light' : 'table-row-dark'}
                                columns={columns}
                                dataSource={data}
                                pagination={false}
                            />
                            <div className='row'>
                                <SizedActionButton buttonAction={() => this.addRowToUsageDetails(index)} buttonText={'Add New'} />
                                <SizedActionButton 
									buttonAction={() => handleApplyAdjustmentToAllSelectedUsages(index, usageRowViewIndex)} 
									buttonText={'Apply Adjustment to All Selected Usages'} 
									disabled={isThisApplyAdjustmentToAllSelectedUsagesButtonDisabled(index, usageDetailsIndex, usageRowViewIndex)}
								/>
                            </div> 
                        </div>
                    )
                }
            })               

        usage.usageDetails.reduce((acc, obj) => {
            const cleanedObj = { ...obj };

            delete cleanedObj.id;
            delete cleanedObj.errorMessage;
            delete cleanedObj.licenseRefID;
            delete cleanedObj.userAdjustment;
            delete cleanedObj.currencyCode;

            const isValueEmpty = (value: unknown): boolean => {
                if (value == null) return true;
                if (typeof value === "string") return value.trim() === "" || value === "0";
                if (typeof value === "number") return value === 0;
                if (Array.isArray(value)) return value.length === 0;
                if (typeof value === "boolean") return value === false;
                return false;
            }

            const isCompletelyEmpty = Object.values(cleanedObj).every(isValueEmpty);

            if (!isCompletelyEmpty) {
                acc.push(cleanedObj);
                usageDetailsGridData.push(cleanedObj);
            }

            return acc;
        }, []);}

                let gridData = []
                gridData = usageDataGridTableData.fields.filter(
                    x => !x.hidden && x.componentInstance === USAGE_ROWS_SECTION_KEY && x.isInTheBody
                );
                if (this.props.activeComponentView?.fields && this.props.activeComponentView?.fields?.length > 0 && this.props.activeComponentView.viewName !== DEFAULT_VIEW_NAME) {
                    gridData = this.props.activeComponentView.fields.filter(
                        x => !x.hidden && x.componentInstance === USAGE_ROWS_SECTION_KEY && x.isInTheBody
                    );
                }
                const sendingLicenseeView = gridData.find(item => item.name === 'sendingLicensee');

        return (
            <tr className="usageRowDropdown" id={`usage-maintenance-details-grid-row-dropdown`}>
                <td colSpan={amountOfColumns}>
                    <div>
                    <UsageBodyFields 
                        usage={usage} 
                        changeUsageData={changeUsageData} 
                        getMaxWidth={getMaxWidth}
                        dataGridTableData={usageDataGridTableData} 
                        gridData={gridData}
                        lookupValues={lookupValues}
                    />
                        <If condition={parseFloat(usage.amount) > 0}>
                            <SizedReadOnlyText label={this.viewData[USAGE_AMOUNT_STATE_KEY]} value={usage.amount} size={readOnlyTextSize} />
                        </If>
                        {sendingLicenseeView && !sendingLicenseeView.hidden && <SizedReadOnlyText label={sendingLicenseeView.data} value={usage.sendingLicensee} size={readOnlyTextSize} />}
                        <PerformanceNumbersSection 
                            usage={usage} 
                            usageNumberInSearchExclude={usageNumberInSearchExclude}
                            isEditable={this.props.isNewUsageRow}
                            onChange={this.props.onChangePerformanceNumbers}
                        />

                        {usageDetailsGridData.length > 0 && <DataGridTable
                            dataGridTableData={usageDataGridTableData}
                            componentInstance={USAGE_DETAILS_ROWS_SECTION_KEY}
                            tableContents={usageDetailsGridData}
                            stateKey={USAGE_DETAILS_ROWS_SECTION_KEY}
                            addUsageDetailsRowData={addUsageDetailsRowData}
                            onUpdateUsageRowDetails={this.onUpdateUsageRowDetails.bind(this)}
                            showRowNumber={false}
                            sortData={undefined}
                            lookupValues={lookupValues}
                            changeData={changeData}
                            addUsageDetailsShareIPRow={addUsageDetailsShareIPRow}
                            onClickAddUsageDetails={this.onClickAddUsageDetails}
                            data-testId={"usage-details-grid-table"}
                        />}
                        <div>{tableList}</div>
                    </div>
                </td>
            </tr>
        );
    }
}